import {
  createApi,
  fetchBaseQuery,
  BaseQueryApi,
} from "@reduxjs/toolkit/query/react";
// import { RootState } from "../../types/rtk/api-config/types";
import { config as appConfig } from "../../config";
import { RootState } from "../../types/rtk/api-config/types";
import { setAuth } from "../auth/auth";

const query = fetchBaseQuery({
  baseUrl: appConfig.REACT_APP_APIV4_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;

    if (token) {
      headers.set("authorization", `JWT ${token}`);
    }

    return headers;
  },
});

const baseQuery = async (args: any, api: BaseQueryApi, extraOptions: {}) => {
  let result = await query(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    // Token expired or invalid - clear auth state
    api.dispatch(
      setAuth({
        token: undefined,
        mail_token: undefined,
      })
    );
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQuery,
  endpoints: () => ({}),
  tagTypes: ["Animal"],
});
